import { Component, EventEmitter, Output } from '@angular/core';
import { ReadFile } from 'ngx-file-helpers';
import { BoolInput } from '../../decorators/BoolInput'

@Component({
  selector: 'file-dropzone',
  templateUrl: './file-dropzone.html',
})
export class FileDropzoneComponent {
  @Output() drop: EventEmitter<File> = new EventEmitter()
  @BoolInput() hidePhrase: boolean
  file: ReadFile
  reading: boolean = false
  
  addFile(file: ReadFile) {
    this.file = file
    this.drop.emit(file.content)
  }  
}



// WEBPACK FOOTER //
// ./src/components/file-dropzone/file-dropzone.ts